import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MapaCurricularFiltrosService } from '../_services/mapa-curricular-filtros.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'mapa-curricular-filtros',
  standalone: false,
  templateUrl: 'mapa-curricular-filtros.component.html',
  styleUrls: ['../mapa-curricular.component.scss']
})

export class MapaCurricularFiltrosComponent implements OnInit {

  filtrosForm: UntypedFormGroup;

  public areas: any[];
  public cursos: any[];
  public ambitos: any[];
  public tags: any[];
  goalsCategories: any[];

  @Input()
  periodos;

  @Input()
  showBulkActions = false;

  @Input()
  activeConnections;

  @Output()
  selectedColumn = new EventEmitter<{ grouperID: number, checked: boolean }>();

  @Output()
  hideMe = new EventEmitter<boolean>();

  @Output()
  unitsByYear = new EventEmitter();

  @Output()
  cleanConnections = new EventEmitter();

  @Output()
  showConnectedOnly = new EventEmitter();

  queryParams = {
    ambitos: [],
    tags: [],
    areas: new Array(),
    cursos: [],
    descripcion: ''
  };

  constructor(private fb: UntypedFormBuilder,
    private filtrosService: MapaCurricularFiltrosService,
    private route: ActivatedRoute,
    private router: Router) {
  }

  ngOnInit() {
    this.route.data.subscribe((data: { areas: any[], cursos: any[], ambitos: any[], tags: any[], categoriasMetas: any[] }) => {
      this.areas = data.areas;
      this.cursos = data.cursos;
      this.ambitos = data.ambitos;
      this.tags = data.tags;
      this.goalsCategories = data.categoriasMetas;
    });
    this.route.queryParams.subscribe((params: { ambitos, tags, areas, cursos, descripcion }) => {
      const paramsObj = {
        ambitos: params.ambitos && params.ambitos.length > 0 ? params.ambitos.split(',') : '',
        tags: params.tags && params.tags.length > 0 ? params.tags.split(',') : '',
        areas: params.areas && params.areas.length > 0 ? params.areas.split(',') : '',
        cursos: params.cursos && params.cursos.length > 0 ? params.cursos.split(',') : '',
        descripcion: params.descripcion ? params.descripcion : ''
      };
      this.queryParams = paramsObj;
      this.filtrosService.filtros = paramsObj;
      this.filtrosService.updateFiltro({ 'filtros': paramsObj });
    });
    this.buildForm();
  }

  log(event) {
    console.log(event);
  }

  buildForm() {
    const columnasSelected = ['tipo-4'];
    /*if (true || +this.route.snapshot.paramMap.get('getUnidades') == 1) {
      columnasSelected.push('unidades');
    }*/
    // TODO: Remover el elemento unidades de las opciones programáticamente.
    this.filtrosForm = this.fb.group({
      nested: this.fb.group({
        ambitos: [this.queryParams.ambitos],
        areas: [this.queryParams.areas],
        cursos: [this.queryParams.cursos],
        descripcion: this.queryParams.descripcion,
        tags: [this.queryParams.tags]
      }),
      detalles: ['']
    });

    this.onChange();
  }

  columnSelect(grouperID, checked) {
    this.selectedColumn.emit({ grouperID, checked });
  }

  limpiarConexiones() {
      if (this.activeConnections) {
        this.showConnectedOnly.emit();
      }
      this.cleanConnections.emit();
  }

  onChange() {
    const that = this;
    this.filtrosForm.get('detalles').valueChanges.subscribe(value => {
      this.filtrosService.updateFiltro({ 'detalles': value });
    });
    this.filtrosForm.get('nested').valueChanges
      .pipe(debounceTime(250))
      .subscribe(value => {
        const filters = JSON.parse(JSON.stringify(value));
        const paramsObj = {
          ambitos: value.ambitos ? value.ambitos.join() : '',
          tags: value.tags ? value.tags.join() : '',
          areas: value.areas ? value.areas.join() : '',
          cursos: value.cursos ? value.cursos.join() : '',
          descripcion: value.descripcion
        };

        this.router.navigate([], { queryParams: paramsObj });
        this.filtrosService.filtros = filters;
        that.filtrosService.updateFiltro({ 'filtros': filters });
      });
  }
}
